function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

import React, { useEffect, useState } from "react";
import { filterEventsByMonth } from "../../utils/calendar";
import { BuyEventPopup } from "../Popups/BuyEventPopup";
import { ActivityItem } from "./ActivityItem";
import { StyledItems, StyledLine, StyledTitle, StyledUl, StyledWrapper } from "./styles";
export var Activity = function Activity(_ref) {
  var events = _ref.events,
    months = _ref.months,
    urlParams = _ref.urlParams,
    promocode = _ref.promocode,
    formats = _ref.formats,
    loadFormats = _ref.loadFormats,
    cleanFormats = _ref.cleanFormats,
    allTickets = _ref.allTickets,
    loadTickets = _ref.loadTickets,
    getPromocode = _ref.getPromocode,
    addShop = _ref.addShop,
    as = _ref.as;

  var _useState = useState(false),
    isBuyPopupOpen = _useState[0],
    setBuyPopupOpen = _useState[1];

  var _useState2 = useState({}),
    currentEvent = _useState2[0],
    setEvent = _useState2[1];

  var handleClickEvent = function handleClickEvent(currentEvent, cityId) {
    setEvent(
      _extends({}, currentEvent, {
        cityId: cityId,
      })
    );
    setBuyPopupOpen(true);
  };

  useEffect(
    function () {
      if (Object.keys(urlParams).length > 0 && events.length > 0) {
        var eventParam = events.find(function (e) {
          return (
            e.event_public_id === urlParams.event_id && e.city.id === Number(urlParams.city_id)
          );
        });
        if (eventParam) handleClickEvent(eventParam, +urlParams.city_id);
      }
    },
    [urlParams, events]
  );
  return /*#__PURE__*/ React.createElement(
    "section",
    null,
    /*#__PURE__*/ React.createElement(
      StyledUl,
      null,
      months.map(function (item, i) {
        return filterEventsByMonth(events, item).length > 0
          ? /*#__PURE__*/ React.createElement(
              "li",
              {
                key: item.month + " " + i,
              },
              /*#__PURE__*/ React.createElement(
                StyledWrapper,
                null,
                /*#__PURE__*/ React.createElement(StyledTitle, null, item.month + " " + item.year),
                /*#__PURE__*/ React.createElement(StyledLine, null)
              ),
              /*#__PURE__*/ React.createElement(
                StyledItems,
                null,
                filterEventsByMonth(events, item).map(function (event, i) {
                  return /*#__PURE__*/ React.createElement(ActivityItem, {
                    event: event,
                    onClickEvent: handleClickEvent,
                    key: "" + event.event.public_id + i,
                  });
                })
              )
            )
          : null;
      })
    ),
    isBuyPopupOpen &&
      /*#__PURE__*/ React.createElement(BuyEventPopup, {
        statePopupHandler: setBuyPopupOpen,
        setEvent: setEvent,
        currentEvent: currentEvent,
        promocode: promocode,
        formats: formats,
        loadFormats: loadFormats,
        cleanFormats: cleanFormats,
        as: as,
        loadTickets: loadTickets,
        allTickets: allTickets,
        addShop: addShop,
        getPromocode: getPromocode,
      })
  );
};
